module.exports = __webpack_public_path__ + "static/media/muffins-choc-chip-tower.31641d02.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/2017-11-4/muffins-choc-chip-tower.jpg
// module id = 813
// module chunks = 0